import { featureFlags } from "./featureFlags";

const SUPER_ADMIN_MARKERS = [
    "super admin",
    "super_admin",
    "supererp_super_admin",
];

function normalize(value) {
    return String(value || "").trim().toLowerCase();
}

function planTokens(value) {
    return normalize(value)
        .split("_")
        .map((part) => part.trim())
        .filter(Boolean);
}

function roleBucket(authInfo) {
    return [
        authInfo?.role,
        authInfo?.user_roles,
        authInfo?.user_role_names,
        authInfo?.userInfo?.user_roles,
        authInfo?.userInfo?.user_role_names,
    ]
        .filter(Boolean)
        .join(",")
        .toLowerCase();
}

function isSuperAdmin(authInfo) {
    if (normalize(authInfo?.subscription) === "supererp") return true;
    if (normalize(authInfo?.subscription_type) === "supererp") return true;

    const roles = roleBucket(authInfo);
    return SUPER_ADMIN_MARKERS.some((marker) => roles.includes(marker));
}

function hasAllowedPlan(authInfo) {
    const tokens = [
        ...planTokens(authInfo?.subscription),
        ...planTokens(authInfo?.subscription_type),
    ];

    return tokens.includes("standard") || tokens.includes("pro");
}

export function hasWorkflowAccess(authInfo) {
    if (!featureFlags.workflows) return false;
    if (!authInfo) return false;
    if (isSuperAdmin(authInfo)) return true;
    return hasAllowedPlan(authInfo);
}

export function hasATSAccess(authInfo) {
    if (!authInfo) return false;
    if (isSuperAdmin(authInfo)) return true;
    return hasAllowedPlan(authInfo);
}

function hasProPlan(authInfo) {
    const tokens = [
        ...planTokens(authInfo?.subscription),
        ...planTokens(authInfo?.subscription_type),
    ];
    return tokens.includes("pro");
}

export function hasChatAccess(authInfo) {
    if (!featureFlags.aiChat) return false;
    if (!authInfo) return false;
    if (isSuperAdmin(authInfo)) return true;
    return hasProPlan(authInfo);
}
